export default {
  textColor: 'brandOne20',
  buttonStyle: 'secondaryInverseOutline',
  teamReference: 'Royal Kennel Club Pet Insurance UK',
} as const;
